var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showMeCurrent
    ? _c("div", { staticClass: "green-circle" }, [
        _c("div", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$translate("Phywe::Template.greenBubbleSavingText")
            )
          }
        }),
        _vm._v(
          "\n  " +
            _vm._s(
              _vm._f("currency")(
                (
                  _vm.showMeCurrent.singlePrice.default.price.value *
                    _vm.currentItem.variation.unitsContained -
                  _vm.currentItem.prices.default.price.value
                ).toFixed(2)
              )
            ) +
            "\n  "
        ),
        _c("br"),
        _vm._v("\n  (" + _vm._s(_vm.showMeCurrent.ersparnisProzent) + "%)\n")
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }